// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1JWcy","content":"LayoutSettings_content__2Mwc6"};